const _excluded = ["label", "required", "renderDropdownData", "options", "dataId", "placeholder", "disabled", "maxItemsOverlay", "id", "sortOrder", "sortStrategy", "styles", "isLabelHidden", "isErrorHidden", "customSearch"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import { useController } from 'react-hook-form';
import { SearchDropdown } from '.';
import { FormField } from '../../FormField';
import { jsx as _jsx } from "react/jsx-runtime";
export const ControlledSearchDropdown = _ref => {
  let {
      label,
      required,
      renderDropdownData,
      options,
      dataId,
      placeholder = '',
      disabled,
      maxItemsOverlay,
      id,
      sortOrder,
      sortStrategy,
      styles,
      isLabelHidden,
      isErrorHidden,
      customSearch
    } = _ref,
    controlProps = _objectWithoutProperties(_ref, _excluded);
  const {
    field: {
      onChange,
      value
    },
    fieldState: {
      error
    }
  } = useController(controlProps);
  const handleChangeToNoValueWithNull = item => {
    if (!item) onChange(null);else onChange(item);
  };
  const errorMessages = !isErrorHidden && error !== null && error !== void 0 && error.message ? [error.message] : [];
  return /*#__PURE__*/_jsx(FormField, {
    label: label,
    labelHidden: isLabelHidden,
    errorMessages: errorMessages,
    required: required,
    children: /*#__PURE__*/_jsx(SearchDropdown, {
      onChange: handleChangeToNoValueWithNull,
      value: value,
      renderData: renderDropdownData,
      optionList: options,
      dataId: dataId,
      placeholder: placeholder,
      disabled: disabled,
      maxItemsOverlay: maxItemsOverlay,
      id: id,
      sortOrder: sortOrder,
      sortStrategy: sortStrategy,
      styles: styles,
      customSearch: customSearch
    })
  });
};